export enum TaxRateType {
  Default = 1,
  Custom = 2,
  TaxFree = 3,
}
